import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@mui/material";
import { format } from "date-fns";
import { useUser } from "../../../api/useAuth";

type CancelledNotesDialogProps = {
    isOpen: boolean;
    onConfirm: (notes: string) => void;
    onCancel: () => void;
};

export const CancelledNotesDialog = ({ isOpen, onConfirm, onCancel }: CancelledNotesDialogProps) => {
    const [notes, setNotes] = useState("");
    const { data: user } = useUser();

    const isNotesEmpty = notes.trim() === "";

    const handleConfirm = () => {
        const currentDate = format(new Date(), "dd-MM-yyyy HH:mm");
        const userName = `${user?.first_name} ${user?.last_name}`;
        const notesWithSignature = `${notes}\n${userName}: ${currentDate}`;
        onConfirm(notesWithSignature);
        setNotes("");
    };

    const handleCancel = () => {
        setNotes("");
        onCancel();
    };

    return (
        <Dialog open={isOpen} onClose={handleCancel} maxWidth="sm" fullWidth>
            <DialogTitle>Motivo do cancelamento</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Notas"
                    fullWidth
                    multiline
                    rows={4}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Indique o motivo do cancelamento..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancelar</Button>
                <Button onClick={handleConfirm} variant="contained" disabled={isNotesEmpty}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

